<template>

    <div class="main">

        <!-- Modal -->
        <div class="modal fade" id="sugerenciasModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content sugerencias-busqueda">
                    <!-- Modal info -->


                        <h3>Sugerencias de búsqueda</h3>
                        <p>Para obtener mejores resultados de búsqueda, puede seguir estas sugerencias:</p>
                        <ul>
                            <li>Si no conoce el ID de la licitación, puede buscar por el nombre de la misma en el filtro <strong>ID de
                                licitación</strong>.
                            </li>
                            <li>Si no encuentra el resultado que buscaba, favor verifique los criterios ingresados o realice una
                                búsqueda con menos criterios.
                            </li>
                            <li>Si está buscando información acerca de procesos anteriores al año <strong>2010</strong>
                                por favor envie una solicitud vía <a href="https://contrataciones.gov.py/mesa-de-ayuda.html">Mesa de ayuda</a>
                                o a traves de los medios habilitados para el efecto
                            </li>
                            <li>Revisa la ortografía de tu búsqueda</li>
                            <li>Prueba con otras palabras más generales</li>
                            <li>Inténtalo con palabras diferentes que signifiquen lo mismo</li>
                            <li>Amplía la búsqueda utilizando menos palabras</li>
                        </ul>

                </div>
            </div>
        </div>
        <!-- Modal codigo embebible-->
        <div class="modal fade" id="codigoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content sugerencias-busqueda">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title">Código embebible</h4>
                    </div>
                    <div class="modal-body">
                        <p>Puedes incluir la visualización en tu sitio copiando y
                            pegando el siguiente código:</p>
                        <textarea cols="40" rows="10" id="embedcode" style="background: transparent;">&lt;iframe src="https://www.contrataciones.gov.py/datos/visualizaciones//mapa-obras#/map?llamado_slug={{ llamado }}" style="width: 1200px; height: 1200px; border: none; padding: 0; margin: 0;"&gt;&lt;/iframe&gt;</textarea>
                    </div>


                </div>
            </div>
        </div>
        <nav class="navbar navbar-fixed-top" id="topnav-menu">
        <div class="container-fluid">

            <div class="row ">
                <div class="col-md-4 col-xs-12">
                    <div class="col-md-1 col-xs-1 pull-left">
                        <span style="font-size:30px;cursor:pointer" v-on:click="openNav()">&#9776;
                        </span>
                    </div>
                    <div class="col-md-10 col-xs-10 pull-left">
                        <a href="https://www.contrataciones.gov.py">
                            <img :src="getImgUrl('Logo DNCP.svg')">
                        </a>
                    </div>
                </div>
                <div class="col-md-4 hide-on-mobile center-block slogan">
                    PORTAL DE LA DIRECCIÓN NACIONAL DE
                            CONTRATACIONES PÚBLICAS DE LA REPÚBLICA DEL PARAGUAY
                </div>
                <div class="col-md-2 hide-on-mobile pull-right">
                    <img alt="Datos abiertos"  :src="getImgUrl('datos-abiertos.png')">
                </div>
            </div>

        </div>
        </nav>
        <div class="container-fluid">

            <div class="row">
            <!-- Buscador -->
                <form >
                <div id="mySidenav" class="sidebar sidenav col-md-3 col-lg-3 col-xs-12">
                    <div class="form-group row">
                        <br />
                    </div>
                    <div class="form-group row">

                        <label class="control-label" >Filtros</label>
                    </div>
                    <div class="form-group row">
                        <hr>
                    </div>
                    <!-- Filtros por categorias a usar despues
                    <div class="form-group row">
                        <div class="col-md-3">
                        <span style="cursor:pointer">
                          <img v-bind:src="edificio"  style="max-width:80%" v-on:click="seleccion_categoria('edificios')">
                        </span>
                        </div>
                        <div class="col-md-3">
                        <span style="cursor:pointer">
                          <img  v-bind:src="camino" v-on:click="seleccion_categoria('caminos')" style="max-width:80%">
                        </span>
                        </div>
                        <div class="col-md-3">
                        <span style="cursor:pointer">
                          <img v-bind:src="puente" v-on:click="seleccion_categoria('puentes')" style="max-width:80%">
                        </span>
                        </div>
                        <div class="col-md-3">
                        <span style="cursor:pointer">
                          <img v-bind:src="otros" v-on:click="seleccion_categoria('otros')" style="max-width:80%">
                        </span>
                        </div>
                        <label class="control-label" style="font-size: 10px; padding-top: 13%">Ver más</label>
                    </div> -->
                    <div class="form-group row">
                        <label class="control-label" for="nro_nombre_licitacion">ID/Nombre de Licitación</label>
                        <input type="text" id="nro_nombre_licitacion" name="nro_nombre_licitacion" class="form-control"
                               v-model="id_licitacion" >
                    </div>
                    <div class="form-group"><label class="control-label">Categoría</label>
                        <div class="input-group">
                            <v-select ref="select-categoria" v-model="source" :options="sources" id="categorias" label="nombre"
                                      multiple >
                                <template slot="no-options">No se han encontrado resultados</template>

                            </v-select>
                            <span class="input-group-btn">
                            <button @click="handleSelectClick('select-categoria')" class="btn btn-default" type="button" data-select2-open="categorias">
                                <span class="glyphicon glyphicon-list naranja"></span>
                            </button>
                        </span>
                        </div>
                    </div>
                    <div class="form-group"><label class="control-label">Tipo de Procedimiento</label>
                        <div class="input-group select2-bootstrap-append">
                            <div class="input-group">
                                <v-select  ref="select-tipo-procedimiento" v-model="tipoProc" :options="tiposProc" id="tipos_procedimiento"
                                          label="nombre" multiple>
                                    <template slot="no-options">No se han encontrado resultados</template>

                                </v-select>
                                <span class="input-group-btn">
                                <button @click="handleSelectClick('select-tipo-procedimiento')" class="btn btn-default" type="button" data-select2-open="categorias">
                                    <span class="glyphicon glyphicon-list naranja"></span>
                                </button>
                            </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group"><label class="control-label">Convocante</label>
                        <div class="input-group">
                            <v-select  ref="select-convocante" v-model="convocante" :options="convocantes" id="convocantes" label="nombre_simple"
                                      multiple>
                                <template slot="no-options">No se han encontrado resultados</template>

                            </v-select>
                            <span class="input-group-btn">
                            <button @click="handleSelectClick('select-convocante')" class="btn btn-default" type="button" data-select2-open="categorias">
                                <span class="glyphicon glyphicon-list naranja"></span>
                            </button>
                        </span>
                        </div>
                    </div>
                    <div class="form-group"><label class="control-label">Etapa</label>
                        <div class="input-group">
                            <v-select  ref="select-etapa" v-model="etapa" :options="etapas" id="etapas_licitacion" label="descripcion"
                                      multiple>
                                <template slot="no-options">No se han encontrado resultados</template>

                            </v-select>
                            <span class="input-group-btn">
                            <button @click="handleSelectClick('select-etapa')" class="btn btn-default" type="button" data-select2-open="etapas_licitacion">
                                <span class="glyphicon glyphicon-list naranja"></span>
                            </button>
                        </span>
                        </div>
                    </div>
                    <div class="form-group"><label class="control-label" for="fecha_desde">Fecha Desde</label>
                        <div class="input-group select2-bootstrap-append">
                            <datepicker :typeable="true" ref="picker-fecha-desde" v-model="fecha_desde" name="fecha_desde" id="fecha_desde"
                                        :language="languages.es" format="dd-MM-yyyy" ></datepicker>
                            <span class="input-group-btn">
              <button @click="handleDatepickerClick('picker-fecha-desde')" class="btn btn-default" type="button" data-target-open="fecha_desde">
                  <span class="glyphicon glyphicon-calendar naranja"></span>
              </button>
          </span>
                        </div>
                    </div>
                    <div class="form-group"><label class="control-label" for="fecha_hasta">Fecha Hasta</label>
                        <div class="input-group select2-bootstrap-append">
                            <datepicker :typeable="true" ref="picker-fecha-hasta" v-model="fecha_hasta" name="fecha_desde" id="fecha_hasta"
                                        :language="languages.es" format="dd-MM-yyyy" ></datepicker>
                            <span class="input-group-btn">
              <button @click="handleDatepickerClick('picker-fecha-hasta')" class="btn btn-default" type="button" data-target-open="fecha_hasta">
                  <span class="glyphicon glyphicon-calendar naranja"></span>
              </button>
          </span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="control-label">Tipo de Fecha</label>
                        <div class="input-group select2-bootstrap-append">
                            <div class="input-group">
                                <v-select ref="select-tipo-fecha" v-model="tipoFecha" :options="tiposFecha" id="tipo_fecha"
                                          label="descripcion" >
                                    <template slot="no-options">No se han encontrado resultados</template>
                                    <template slot="no-options">
                                        Por favor, introduza 3 caracteres
                                    </template>
                                </v-select>
                                <span class="input-group-btn">
                                <button class="btn btn-default" type="button" data-select2-open="tipo_fecha"
                                        @click="handleSelectClick('select-tipo-fecha')">
                                    <span class="glyphicon glyphicon-list naranja"></span>
                                </button>
                            </span>
                            </div>
                        </div>
                    </div>
                    <!-- Filtros Avanzdos -->
                    <div class="form-group" v-on:click="changeFilter()">
                        <div id="filtros-avanzados" class="panel-group" role="tablist" aria-multiselectable="true" style="margin-top: 10px; cursor: pointer; margin-bottom: 6px">
                            <div class="panel panel-default">
                                <div class="panel-heading" role="tab" id="headingOne">
                                    <h4 class="panel-title">
                                        <a data-toggle="collapse"  data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne" class="">
                                            Criterios de Búsqueda Avanzada
                                        </a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="!basicFilter">
                        <div class="form-group"><label class="control-label">Características Especiales</label>
                            <div class="input-group">
                                <v-select v-model="caracteristicasEspecialesSelected" :options="caracteristicasEspecialesList"
                                          label="descripcion" name="caracteristicas" multiple >
                                    <template slot="no-options">No se han encontrado resultados</template>
                                </v-select>
                                <span class="input-group-btn">
                                    <button class="btn btn-default" type="button" data-select2-open="caracteristicas">
                                        <span class="glyphicon glyphicon-list naranja"></span>
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div class="form-group"><label class="control-label">Tipo Convocante</label>
                            <div class="input-group">
                                <v-select v-model="tipoConvocanteSelected" :options="tipoConvocanteList" label="descripcion"
                                          name="tipoConvocante">
                                    <template slot="no-options">No se han encontrado resultados</template>
                                </v-select>
                                <span class="input-group-btn">
                                    <button class="btn btn-default" type="button" data-select2-open="tipoConvocante">
                                        <span class="glyphicon glyphicon-list naranja"></span>
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="control-label">Unidad Contratación/Proyecto</label>
                            <div class="input-group">
                                <v-select label="nombre_simple" :filterable="false" :options="unidadesContratacionList" v-model="unidadContratacion"
                                          @search="onSearchUnidadContratacion" >
                                    <template slot="no-options">
                                        Por favor, introduza 3 caracteres
                                    </template>
                                    <template slot="no-options">No se han encontrado resultados</template>

                                </v-select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="control-label">Código de Contratación</label>
                            <input type="text" class="form-control" v-model="codigoContratacion" >
                        </div>
                        <div class="form-group"><label class="control-label">Productos</label>
                            <div class="input-group">
                                <v-select label="n5_nombre" :filterable="false" :options="productos" v-model="productoSelected"
                                          @search="onSearchProducto" >

                                    <template slot="no-options">No se han encontrado resultados</template>
                                </v-select>
                            </div>
                        </div>
                    </template>

                    <div class="form-group btn-toolbar" role="toolbar">
                        <button class="btn btn-primary btn-xs btn-bottom" type="button" v-on:click="buscar(false)">Buscar</button>
                        <button class="btn btn-xs btn-bottom" type="button" v-on:click="limpiarFiltros()">Nueva Búsqueda</button>
                        <button class="btn btn-xs btn-bottom" type="button" v-on:click="setParamsDNCPBuscador()">Ir a Buscador</button>
                    </div>

                </div>
                </form>


                <!-- Mapa -->
                <div class="sidebar mapa col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-3 col-xs-offset-0" id="main">

                    <l-map ref="map" class="col-md-12" :zoom="zoom" :center="center" :bounds="bounds" style="padding: 0px" id="lmap">


                        <!-- <l-control-layers :position="layersPosition"/>
                        <l-tile-layer  v-for="layer in layers" :key="layer.name" :url="layer.url" :attribution="layer.attribution"
                        layerType="base" :name="layer.name" :visible="layer.visible"></l-tile-layer> -->
                        <v-marker-cluster>
                            <v-marker v-for="l in locations" :key="l.id" :lat-lng="l.latlng">
                                <v-popup :content="l.text"></v-popup>
                            </v-marker>
                        </v-marker-cluster>
                    </l-map>

                </div>

        </div>
        </div>
    </div>
</template>

<script>

    import {
        LMap,
        LTileLayer,
        LMarker,
        LControlLayers,
        VueSelect
    } from "vue2-leaflet";
    import "leaflet/dist/leaflet.css";
    import Datepicker from 'vuejs-datepicker';
    import * as lang from "vuejs-datepicker/src/locale/index";
    import VueNotifications from 'vue-notifications';
    import moment from "moment";
    import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
    import * as Vue2Leaflet from 'vue2-leaflet';
    import {globalStore} from '../main.js'
    import L from 'leaflet';

    export default {
        name: "Map",
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LControlLayers,
            VueSelect,
            Datepicker,
            'v-marker-cluster': Vue2LeafletMarkerCluster,
            'v-marker': Vue2Leaflet.LMarker,
            'v-popup': Vue2Leaflet.LPopup,

        },
        props: {
            msg: String
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Hello there',
                message: 'That\'s the success!'
            },
            showInfoMsg: {
                type: VueNotifications.types.info,
                title: 'Hey you',
                message: 'Here is some info for you'
            },
            showWarnMsg: {
                type: VueNotifications.types.warn,
                title: 'Wow, man',
                message: 'That\'s the kind of warning'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Wow-wow',
                message: 'That\'s the error'
            }
        },
        data() {

            return {
                llamado: '',
                zoom: 7,
                center: L.latLng(-23.297539, -57.632305),
                layers: [
                    {
                        name: "Satelite",
                        visible: false,
                        url:
                            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                        attribution:
                            "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Communit"
                    },
                    {
                        name: "OpenStreetMap",
                        visible: true,
                        url: "https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png",
                        attribution:
                            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    }
                ],
                marker: L.latLng(47.41322, -1.219482),
                layersPosition: "bottomleft",
                autostart: true,
                showDetail: false,
                currentLocation: false,
                projects: null,
                sources: [],
                source: [],
                tipoProc: [],
                tiposProc: [],
                etapas: [],
                etapa: [],
                tipoFecha: null,
                tiposFecha: [],
                baseUrl: globalStore.apiBaseUrl + "doc/",
                REQUEST_TOKEN_URL: globalStore.apiBaseUrl + 'oauth/token',
                convocante: [],
                convocantes: [],
                id_licitacion: null,
                fecha_desde: null,
                fecha_hasta: null,
                languages: lang,
                edificio: this.getImgUrl('Edificios desactivado.svg'),
                camino: this.getImgUrl('Caminos desactivado.svg'),
                puente: this.getImgUrl('Puentes desactivado.svg'),
                otros: this.getImgUrl('Otros desactivado.svg'),
                categorias_obras: [],
                resultado_busqueda: [],
                currentTender: null,
                basicFilter: true,
                caracteristicasEspecialesList: [],
                caracteristicasEspecialesSelected: [],
                tipoConvocanteList: [],
                tipoConvocanteSelected: null,
                unidadContratacion: null,
                unidadesContratacionList: [],
                codigoContratacion: null,
                productos: [],
                productoSelected: null,
                bounds: null,
                locations: [],
                puntos: []
            }
        },
        methods: {
            handleSelectClick(elem){
                const input = this.$refs[elem].$el.querySelector('input');
                input.focus()
            },
            handleDatepickerClick(elem){
                if(this.$refs[elem].isOpen){
                    this.$refs[elem].close();
                } else {
                    this.$refs[elem].showCalendar();
                }
            },
            limpiarFiltros() {
                this.tipoProc = [];
                this.productoSelected = null;
                this.tipoConvocanteSelected = null;
                this.unidadContratacion = null;
                this.codigoContratacion = null;
                this.id_licitacion = null;
                this.fecha_desde = null;
                this.fecha_hasta = null;
                this.convocante = [];
                this.etapa = [];
                this.tipoFecha = null;
                this.source = [];
                this.caracteristicasEspecialesSelected = [];
                this.unidadContratacion = null;
            },
            onSearchProducto(search, loading) {
                if(search.length < 3) {
                    return;
                }
                loading(true);
                this.$http.get(this.baseUrl + 'buscadores/catalogos?order=n5_nombre&codigo_descripcion=' + search)
                    .then(response => {
                        this.productos = response.data['@graph'][0]['list'];
                        loading(false);
                    }, (response) => {
                        if (response.status === 429 || response.status === 401) {
                            this.onSearchProducto(search, loading);
                        }
                    });
            },
            onSearchUnidadContratacion(search, loading) {
                if(search.length < 3) {
                    return;
                }
                loading(true);
                let param = "";
                if(this.convocante.length > 0) {
                    let ids = "";
                    for (let i = 0; i < this.convocante.length; i++) {
                        ids = ids + "," + this.convocante[i].slug;
                    }
                    param = "&dependiente_de_slug="+ ids.substring(1);
                }
                this.$http.get(this.baseUrl + 'parametros/unidades-contratacion?nombre_simple=*' + search+"*"+param)
                    .then(response => {
                        this.unidadesContratacionList = response.data['@graph'][0]['unidad_contratacion']['list'];
                        loading(false);

                    }, (response) => {
                        if (response.status === 429 || response.status === 401) {
                            this.onSearchUnidadContratacion(search, loading);
                        }
                    });
            },
            show() {
                $('#sugerenciasModal').modal('show')
            },
            showCodigo() {
                $('#codigoModal').modal('show')
            },
            hide() {
                $('#sugerenciasModal').modal('hide')
            },
            changeFilter() {
                this.basicFilter = !this.basicFilter;
            },
            putMarkerIcon(map, feature, center, forPopUp, nombre) {
                let otrosIcon = this.getIcon('Otros.svg');
                let edificiosIcon = this.getIcon('Edificios.svg');
                let puentesIcon = this.getIcon('Puentes.svg');
                let caminosIcon = this.getIcon('Caminos.svg');
                let markerIcon = otrosIcon;
                if (feature.properties.tipo !== null) {
                    let tipo = feature.properties.tipo;
                    if (tipo === 'puentes') {
                        markerIcon = puentesIcon;
                    }
                    if (tipo === 'caminos') {
                        markerIcon = caminosIcon;
                    }
                    if (tipo === 'edificio') {
                        markerIcon = edificiosIcon;
                    }
                }

                let nombres = [];
                let nuevo = '';
                for (let a = 0; a < (nombre.length-5); a+=5) {
                    nombres.push(nombre.split(' ').slice(a, a+5))
                }
                for (let b = 0; b < nombres.length; b++) {
                    if(nombres[b].length === 0){
                        break;
                    }
                    nuevo += nombres[b].join(" ") + "<br/>"
                }

                L.marker(center, {icon: markerIcon})
                .bindTooltip(nuevo, {className: 'myCSSClass'})
                    .on('click', function(e){
                        map.setView(e.latlng, 20);
                    }).addTo(map).bindPopup(forPopUp);

            },
            getIcon(iconName) {
                return L.icon({
                    iconUrl: this.getImgUrl(iconName),
                    iconSize: [38, 95], // size of the icon
                    shadowSize: [50, 64], // size of the shadow
                    iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
                    shadowAnchor: [4, 62],  // the same for the shadow
                    popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
                });
            },
            showParentsShapes(borrar) {
                let map = this.$refs.map.mapObject;
                let objeto = this;
                if(borrar) {
                    map.eachLayer(function (layer) {
                        if (layer.options.url) {
                            return;
                        }
                        map.removeLayer(layer);
                    });
                    this.puntos = []
                }

                let geoList = [].concat.apply([], Object.values(this.resultado_busqueda));
                let isSlug = typeof this.$route.query.llamado_slug !== 'undefined';
                for (let i = 0; i < geoList.length; i++) {
                    let geos = geoList[i].geo;
                    if (!geos) {
                        this.show();
                        return;
                    }
                    for (let j = 0; j < geos.length; j++) {
                        let currentGeo = geos[j].geojson;
                        let currentTender = geoList[i];
                        let keyEtiquetas = Object.keys(currentTender.etiquetas);
                        let convocatoria_slug = currentTender.convocatoria_id;
                        let etapa_licitacion = null;
                        if(isSlug) {
                            convocatoria_slug = this.$route.query.llamado_slug;
                            etapa_licitacion= currentTender.estado.nombre;
                        } else {
                            etapa_licitacion = currentTender.etapa_licitacion.nombre;
                        }

                        let etiquetaSpan = '';
                        if(isSlug) {
                            for (let et = 0; et < currentTender.etiquetas.length; et++) {
                                if (currentTender.etiquetas[et] !== 'geo') {
                                    etiquetaSpan += '<span class="label label-default">' + currentTender.etiquetas[et] + '</span>';
                                }
                            }
                        } else {
                            for (let et = 0; et < keyEtiquetas.length; et++) {
                                if (keyEtiquetas[et] !== 'geo') {
                                    etiquetaSpan += '<span class="label label-default">' + keyEtiquetas[et] + '</span>';
                                }
                            }
                        }


                            let formatDate = moment(currentTender.fecha_entrega_oferta).format('DD/MM/YYYY hh:mm');
                        this.llamado = currentTender.convocatoria_id;
                        let forPopUp = ' \n' +
                            '            <article style="margin-top: -11%">\n' +
                            '                <div class="form-group row">\n' +
                            '              <header>\n' +
                            '                  <h3>\n' +
                            '                      <a href="https://www.contrataciones.gov.py/licitaciones/convocatoria/' + convocatoria_slug.split(",")[0] + '.html ">\n' +
                            '                          <strong>' + currentTender.nombre_licitacion + ' </strong>\n' +
                            '                      </a>\n' +
                            '                      <br>\n' +
                            '                      <div class="row">\n' +
                            '                      <span class="tags" style="margin-top: 2%;">\n' +
                            etiquetaSpan +
                            '                    </span>\n' +
                            '                      </div>\n' +
                            '                  </h3>\n' +
                            '              </header>\n' +
                            '                </div>\n' +
                            '                  <div class="form-group row">\n' +
                            '                  <strong>ID de Licitación:</strong>' + currentTender.id_llamado + '\n' +
                            '                  </div>\n' +
                            '                  <div class="form-group row">\n' +
                            '                      <strong>Convocante:</strong> ' + currentTender.convocante + '\n' +
                            '                  </div>\n' +
                            '              <div class="form-group row">\n' +
                            '                  <strong>Categoría:</strong> ' + currentTender.categoria.nombre + '\n' +
                            '              </div>\n' +
                            '\n' +
                            '              <div class="form-group row">\n' +
                            '                  <strong>Etapa:</strong> ' + etapa_licitacion + '\n' +
                            '              </div>\n' +
                            '\n' +
                            '              <div class="form-group row">\n' +
                            '                  <strong>Tipo de Procedimiento:</strong> ' + currentTender.tipo_procedimiento.nombre + '\n' +
                            '              </div>\n' +
                            '\n' +
                            '              <div class="form-group row">\n' +
                            '                  <strong>Fecha de Entrega de Ofertas:</strong> ' + formatDate + '\n' +
                            '              </div>\n' +
                            '\n' +
                            '            </article>\n' +
                            '              <div class="form-group btn-toolbar" style=" margin-top: 2%">\n' +
                            '                      <a style="" href="https://www.contrataciones.gov.py/licitaciones/convocatoria/' + convocatoria_slug.split(",")[0] + '.html" class="btn btn-xs btn-bottom botones">Ver Convocatoria</a>\n' +
                            '                      <a href="https://www.contrataciones.gov.py/stje-cliente/public/investigaciones/escrito_de_denuncia_edit.html" class="btn btn-xs btn-bottom botones">Denunciar</a>\n' +
                            '                            <button class="btn btn-xs btn-bottom botones" type="button" ' +
                            ' onclick=    "$(\'#codigoModal\').modal(\'show\')"> Incluir en mi web </button> '+
                            '              </div>\n' +
                            '              <div class="form-group row" style=" margin-top: 2%">\n' +
                            '              </div>\n' +
                            '\n' +
                            '          ';

                        L.geoJson(currentGeo, {
                            onEachFeature: (feature, layer) => {

                                let bounds = new L.LatLngBounds(layer.getLatLngs());


                                if(Object.keys(bounds).length === 0 || bounds._northEast.lat > -20 || bounds._northEast.lng > -50 ||
                                    bounds._southWest.lat > -20 || bounds._southWest.lng > -50) {

                                } else {
                                    this.puntos.push(layer.getLatLngs());

                                    this.putMarkerIcon(map, feature, bounds.getCenter(), forPopUp, currentTender.nombre_licitacion);
                                }

                            },
                            pointToLayer(feature, latLong) {

                                if(typeof latLong === "undefined" || latLong.lat > -20 || latLong.lng > -50) {

                                } else {
                                    objeto.puntos.push(latLong);
                                    objeto.putMarkerIcon(map, feature, latLong, forPopUp, currentTender.nombre_licitacion);
                                }

                            }
                        })

                            .addTo(map).bindPopup(forPopUp);

                    }

                }
                if(this.resultado_busqueda.length > 0) {

                    let bounds = new L.LatLngBounds( this.puntos);
                    map.fitBounds(bounds);
                    setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 100);


                } else {

                        map.flyTo(L.latLng(-23.297539, -57.632305));

                        this.show();

                }
            },
            getImgUrl: function (image) {
                if (!image) {
                    return null;
                }

                if(process.env.VUE_APP_ASSETS_PREFIX) {
                    return process.env.VUE_APP_ASSETS_PREFIX + require("../assets/" + image);
                } else {
                    return '/datos/mapa' + require("../assets/" + image);
                }


            },
            openNav() {

                if(document.getElementById("mySidenav").className === "hidden") {
                    document.getElementById("mySidenav").className = "sidebar sidenav col-md-3 col-lg-3";
                    document.getElementById("main").className = "sidebar mapa col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-3 col-xs-offset-0";
                } else {
                    document.getElementById("mySidenav").className = "hidden";
                    document.getElementById("main").className = "sidebar mapa col-md-12 col-xs-12";
                }


            },
            getParams(params, buscador) {
                let i;
                params = "?";

                if (this.tipoFecha !== null && (this.fecha_desde === null && this.fecha_hasta === null)) {
                    this.showErrorMsg({title: "", message: 'Debe cargar al menos uno de los filtros de fecha'});
                    return "";
                }
                if ((this.fecha_desde !== null || this.fecha_hasta !== null) && this.tipoFecha === null) {
                    this.showErrorMsg({
                        title: "",
                        message: 'Para filtrar licitaciones entre fechas debe seleccionar que "tipo de fecha" desea usar'
                    });
                    return "";
                }

                if (this.id_licitacion === null && this.tipoFecha === null && this.fecha_desde === null
                    && this.fecha_hasta === null && this.source.length < 1 && this.tipoProc.length < 1
                    && this.convocante.length < 1 && this.etapa.length < 1 && this.caracteristicasEspecialesSelected.length < 1
                && this.tipoConvocanteSelected === null && this.productoSelected === null && this.unidadContratacion === null && this.codigoContratacion === null) {
                    this.showErrorMsg({title: "", message: 'Para realizar búsquedas debe ingresar al menos 1 filtro.'});
                    return "";
                }

                if (this.source.length > 0) {
                    let ids = "";
                    for (i = 0; i < this.source.length; i++) {
                        ids = ids + "," + this.source[i].id;
                    }
                    params = params + "categorias=" + ids.substring(1);
                }
                if (this.id_licitacion !== null && this.id_licitacion !== "") {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "nro_nombre_llamado=" + this.id_licitacion;
                }
                if (this.fecha_hasta !== null && this.fecha_hasta !== "") {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    if(buscador) {
                        params = params + "fecha_hasta=" + moment(this.fecha_hasta).format('DD-MM-YYYY');

                    } else {
                        params = params + "fecha_hasta=" + moment(this.fecha_hasta).format('YYYY-MM-DD');
                    }
                }
                if (this.fecha_desde !== null && this.fecha_desde !== "") {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    if(buscador) {
                        params = params + "fecha_desde=" + moment(this.fecha_desde).format('DD-MM-YYYY');

                    } else {
                        params = params + "fecha_desde=" + moment(this.fecha_desde).format('YYYY-MM-DD');
                    }
                }
                if (this.tipoFecha !== null && this.tipoFecha !== "") {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "tipo_fecha=" + this.tipoFecha.codigo;

                }
                if (this.codigoContratacion !== null && this.codigoContratacion !== "") {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "codigo_contratacion=" + this.codigoContratacion;

                }
                if (this.tipoProc.length > 0) {
                    let ids = "";
                    for (i = 0; i < this.tipoProc.length; i++) {
                        ids = ids + "," + this.tipoProc[i].codigo;
                    }
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "tipos_procedimiento=" + ids.substring(1);
                }
                if (this.convocante.length > 0) {
                    let ids = "";
                    for (i = 0; i < this.convocante.length; i++) {
                        ids = ids + "," + this.convocante[i].codigo;
                    }
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "convocantes=" + ids.substring(1);
                }
                if (this.productoSelected !== null) {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "codigo_catalogo_n4=" + this.productoSelected.n4_codigo;
                }
                if (this.unidadContratacion !== null) {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "convocante_nombre_codigo=" + this.unidadContratacion.codigo;
                }
                if (this.caracteristicasEspecialesSelected.length > 0) {
                    let ids = "";
                    for (i = 0; i < this.caracteristicasEspecialesSelected.length; i++) {
                        ids = ids + "," + this.caracteristicasEspecialesSelected[i].codigo;
                    }
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "marcas=" + ids.substring(1);
                }
                if (this.tipoConvocanteSelected !== null) {
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "convocante_tipo=" + this.tipoConvocanteSelected.codigo;
                }
                if (this.etapa.length > 0) {
                    let ids = "";
                    for (i = 0; i < this.etapa.length; i++) {
                        ids = ids + "," + this.etapa[i].codigo;
                    }
                    if (params !== "?") {
                        params = params + "&";
                    }
                    params = params + "codigo=" + ids.substring(1);
                }
                return params;
            },
            cargarSelectBuscador() {
                this.$http.post(this.REQUEST_TOKEN_URL).then(
                    response => {
                        window.localStorage.setItem("authToken", response.data.access_token);

                    this.$http.get(this.baseUrl + "parametros/categorias")
                        .then(response => {
                            this.sources = response.data['@graph'][0]['categoria']['list'];

                        }, (response) => {
                            if (response.status === 429 || response.status === 401) {
                                this.$http.get(this.baseUrl + "parametros/categorias")
                                    .then(response => {
                                        this.sources = response.data['@graph'][0]['categoria']['list'];

                                    });
                            }
                    });

                    this.$http.get(this.baseUrl + "parametros/tipos-procedimiento")
                        .then(response => {
                            this.tiposProc = response.data['@graph'][0]['tipo_de_procedimiento']['list'];

                        }, (response) => {
                                if (response.status === 429 || response.status === 401) {
                                    this.$http.get(this.baseUrl + "parametros/tipos-procedimiento")
                                        .then(response => {
                                            this.tiposProc = response.data['@graph'][0]['tipo_de_procedimiento']['list'];

                                        });
                                } });
                    this.$http.get(this.baseUrl + "parametros?dominio=ETAPA_LICITACION")
                        .then(response => {
                            this.etapas = response.data['@graph'][0]['parametro']['list'];
                            this.etapas.splice(0, 1);

                        }, (response) => {
                            if (response.status === 429 || response.status === 401) {
                                this.$http.get(this.baseUrl + "parametros?dominio=ETAPA_LICITACION")
                                    .then(response => {
                                        this.etapas = response.data['@graph'][0]['parametro']['list'];
                                        this.etapas.splice(0, 1);
                                    })
                            }
                        });
                    this.$http.get(this.baseUrl + "parametros?dominio=_BUSCADOR_LICITACIONES_TIPO_FECHA")
                        .then(response => {
                            this.tiposFecha = response.data['@graph'][0]['parametro']['list'];

                        }, (response) => {
                            if (response.status === 429 || response.status === 401) {
                                this.$http.get(this.baseUrl + "parametros?dominio=_BUSCADOR_LICITACIONES_TIPO_FECHA")
                                    .then(response => {
                                        this.tiposFecha = response.data['@graph'][0]['parametro']['list'];
                                    })
                            }
                        });
                    this.$http.get(this.baseUrl + "parametros/convocantes?limit=1000")
                        .then(response => {
                            this.convocantes = response.data['@graph'][0]['convocante']['list'];

                        }, (response) => {
                            if (response.status === 429 || response.status === 401) {
                                this.$http.get(this.baseUrl + "parametros/convocantes?limit=1000")
                                    .then(response => {
                                        this.convocantes = response.data['@graph'][0]['convocante']['list'];
                                    })
                            }
                        });
                    this.$http.get(this.baseUrl + "parametros?dominio=MARCA_CONTRATO")
                        .then(response => {
                            this.caracteristicasEspecialesList = response.data['@graph'][0]['parametro']['list'];

                        }, (response) => {
                            if (response.status === 429 || response.status === 401) {
                                this.$http.get(this.baseUrl + "parametros?dominio=MARCA_CONTRATO")
                                    .then(response => {
                                        this.caracteristicasEspecialesList = response.data['@graph'][0]['parametro']['list'];
                                    })
                            }
                        });
                    this.$http.get(this.baseUrl + "parametros?dominio=_BUSCADOR_LICITACION_TIPO_CONVOCANTE")
                        .then(response => {
                            this.tipoConvocanteList = response.data['@graph'][0]['parametro']['list'];

                        }, (response) => {
                            if (response.status === 429 || response.status === 401) {
                                this.$http.get(this.baseUrl + "parametros?dominio=_BUSCADOR_LICITACION_TIPO_CONVOCANTE")
                                    .then(response => {
                                        this.tipoConvocanteList = response.data['@graph'][0]['parametro']['list'];
                                    })
                            }
                        });
                        this.procesarQueryParams();
                        }
                );
            },
            buscar (sin_parametros) {
                let params = "";
                let url = this.baseUrl + "buscadores/licitaciones";
                if (!sin_parametros) {
                    params = this.getParams(params, false);
                    if (params === "") {
                        return;
                    }
                    url = url + params + "&geo=true";
                } else {
                    url = url + "?geo=true&limit=10"
                }

                this.resultado_busqueda = [];
                this.$http.get(url)
                    .then(response => {
                        let pagination  = response.body['@graph'][0]['pagination'];
                        this.resultado_busqueda = response.body['@graph'][0]['list'];
                        this.showParentsShapes(true);
                        if(pagination !== null && pagination['total_pages'] > 1 && !sin_parametros) {
                            for(let pag = pagination.items_per_page; pag < pagination.total_items; pag = pag + pagination.items_per_page) {
                                this.$http.get(url+ "&offset="+pag).then(response => {
                                    this.resultado_busqueda = response.body['@graph'][0]['list'];
                                    this.showParentsShapes(false);
                                }, (response) => {
                                    if (response.status === 429 || response.status === 401) {
                                        this.$http.get(url+ "&offset="+pag).then(response => {
                                            this.resultado_busqueda = response.body['@graph'][0]['list'];
                                            this.showParentsShapes(false);
                                        });
                                    }
                                })
                            }

                        }
                        document.getElementById("mySidenav").className = "hidden";
                        document.getElementById("main").className = "sidebar mapa col-md-12 col-xs-12";
                       // this.showParentsShapes(false);
                    }, (err) => {

                        if (err.status === 429 || err.status === 401) {
                            this.buscar();
                        } else {

                            this.resultado_busqueda = [];
                            this.showParentsShapes(true);
                            this.showWarnMsg({
                                title: "",
                                message: 'No se han encontrado resultados para los criterios de búsqueda indicados'

                            });
                        }
                    });



            },
            procesarQueryParams() {
                let queryParams = this.$route.query;
                // Si no tiene  query params esta accediendo al mapa sin parametros directamente
                if(Object.keys(queryParams).length === 0) {
                    this.buscar(true);
                } else {
                    // Si tiene llamado slug se usa el servicio de convocatoria por slug
                    if("undefined" !== typeof queryParams.llamado_slug) {
                        document.getElementById("topnav-menu").style.display = "none";
                        document.getElementById("mySidenav").style.display = "none";
                        document.getElementById("main").className = "sidebar mapa col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-0";
                        document.getElementById("main").style = "height: 100%; top: 0";
                        document.getElementById("lmap").style = "top: 0; bottom: 0; rigth: 0;";
                            this.$http.get(this.baseUrl + "convocatorias/" + this.$route.query.llamado_slug + "?geo=true")
                            .then(response => {
                                this.resultado_busqueda = response.body['@graph'];
                                this.showParentsShapes();
                            }, (err) => {
                                if (err.status === 429 || err.status === 401) {
                                    this.$http.get(this.baseUrl + "convocatorias/" + this.$route.query.llamado_slug + "?geo=true")
                                        .then(response => {
                                            this.resultado_busqueda = response.body['@graph'];
                                            this.showParentsShapes()});
                                } else {
                                    this.showWarnMsg({
                                        title: "",
                                        message: 'No se han encontrado resultados para los criterios de búsqueda indicados'
                                    });
                                }

                            });
                    // Si no tiene llamado slug se procesan los demas parámetros del buscador esperados
                    } else {
                        if("undefined" !== typeof queryParams.nro_nombre_licitacion) {
                            this.id_licitacion = queryParams.nro_nombre_licitacion;
                        }
                        if("undefined" !== typeof queryParams.etapas_licitacion) {
                            this.etapa = queryParams.etapas_licitacion.split(",");
                        }
                        if("undefined" !== typeof queryParams.fecha_desde) {
                            this.fecha_desde = queryParams.fecha_desde;
                        }
                        if("undefined" !== typeof queryParams.fecha_hasta) {
                            this.fecha_hasta = queryParams.fecha_hasta;
                        }
                        if("undefined" !== typeof queryParams.tipo_fecha) {
                            this.tipoFecha = queryParams.tipo_fecha;
                        }
                        if("undefined" !== typeof queryParams.convocante_codigos) {
                            this.convocante = queryParams.convocante_codigos.split(",");
                        }
                        if("undefined" !== typeof queryParams.categorias) {
                            this.source = queryParams.categorias.split(",");
                        }
                        if("undefined" !== typeof queryParams.unidad_contratacion_codigo) {
                            this.unidadContratacion = queryParams.unidad_contratacion_codigo;
                        }
                        if("undefined" !== typeof queryParams.codigo_contratacion) {
                            this.codigo_contratacion = queryParams.codigo_contratacion;
                        }
                        if("undefined" !== typeof queryParams.codigos_catalogo_n4) {
                            this.productoSelected = queryParams.codigos_catalogo_n4;
                        }
                        if("undefined" !== typeof queryParams.convocante_tipo_codigo) {
                            this.tipoConvocanteSelected = queryParams.convocante_tipo_codigo;
                        }


                        this.buscar(false);
                    }

                }
            },
            seleccion_categoria(cat) {
                switch (cat) {
                    case "edificios":
                        if (this.edificio === this.getImgUrl('Edificios desactivado.svg')) {
                            this.edificio = this.getImgUrl('Edificios.svg');
                            this.categorias_obras.push('edificios');
                        } else {
                            this.edificio = this.getImgUrl('Edificios desactivado.svg');
                            this.categorias_obras.splice(this.categorias_obras.indexOf("edificio"), 1);
                        }
                        break;
                    case "puentes":

                        if (this.puente === this.getImgUrl('Puentes desactivado.svg')) {
                            this.puente = this.getImgUrl('Puentes.svg');
                            this.categorias_obras.push('puentes');
                        } else {
                            this.puente = this.getImgUrl('Puentes desactivado.svg');
                            this.categorias_obras.splice(this.categorias_obras.indexOf("puentes"), 1);
                        }
                        break;
                    case "caminos":

                        if (this.camino === this.getImgUrl('Caminos desactivado.svg')) {
                            this.camino = this.getImgUrl('Caminos.svg');
                            this.categorias_obras.push('caminos');
                        } else {
                            this.camino = this.getImgUrl('Caminos desactivado.svg');
                            this.categorias_obras.splice(this.categorias_obras.indexOf("caminos"), 1);
                        }
                        break;
                    default:
                        if (this.otros === this.getImgUrl('Otros desactivado.svg')) {
                            this.otros = this.getImgUrl('Otros.svg');
                            this.categorias_obras.push('otros');
                        } else {
                            this.otros = this.getImgUrl('Otros desactivado.svg');
                            this.categorias_obras.splice(this.categorias_obras.indexOf("Otros"), 1);
                        }
                        break;
                }

            },
            setParamsDNCPBuscador() {
                let baseBuscadorUrl = "https://www.contrataciones.gov.py/buscador/licitaciones.html";
                let params = "";
                params = this.getParams(params, true);
                if(params === "") {
                    return;
                }
                params = params.replace("nro_nombre_llamado", "nro_nombre_licitacion");
                let win = window.open(baseBuscadorUrl+params, '_blank');
                win.focus();

            }
        },

        created: function () {
            this.cargarSelectBuscador();


        },
        mounted() {
            let a = this;
            $(document).keypress(function(e) {
                if(e.which == 13) {
                    a.buscar(false);
                }
            });
            const map = this.$refs.map.mapObject;
            let addedLayers = this.layers
                .map(l => {
                    return L.tileLayer(l.url, l).addTo(map);
                })
                .reduce(function (acc, cur) {
                    acc[cur.options.name] = cur;
                    return acc;
                }, {});
            let layerControl = L.control.layers(addedLayers, null, {
                position: "topleft"
            });
            layerControl.addTo(map);
            setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
        }
    };

</script>

<style scoped>
    .mapa {
        height: 95vh;
        position: fixed;
        padding: 0px;
    }

    .bottom {
        background-color: #fee9c3;
        background-repeat: repeat-x;
        background-position-y: bottom;
        background-size: 10vw 4vh;
        height: 5vh;
        position: relative;
    }

    .central-logo {
        margin: auto;
        border-radius: 100%;
        width: 25vw;
        height: 25vw;
        background: #fee9c3;
        background-repeat: repeat-x;
        background-size: 10vw 4vh;
        background-position-y: 5.8vw;
        position: absolute;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        top: -5vw;
        z-index: 1000;
    }

    .central-logo img {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
        padding: 5%;
        display: block;
    }

    .info-space {
        height: 80vh;
        width: 50vw;
        background: rgba(255, 242, 218, 0.9);
        padding: 20px;
        margin: 10px;
        margin-top: 2vh;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1000;
        border-radius: 10px;
    }

    .logo-image {
        text-align: center;
        padding-left: 0px;
        padding-right: 0px;
    }

    .logo-image img {
        width: 75%;
    }

    h1 {
        font-size: 1.8em;
        font-weight: bold;
    }

    .main {
        overflow: hidden;
    }

    .info-content {
        max-height: 60vh;
    }

    .info-title {
        min-height: 10vh;
        position: relative;
    }

    .info-title h1 {
        font-size: 3vh;
    }

    .info-title h2 {
        font-weight: bold;
    }

    .slide-content {
        padding-left: 40px;
        padding-right: 40px;
        overflow-y: auto;
        max-height: 35vh;
    }

    .close-button {
        position: absolute;
        top: 2px;
        right: -10px;
        width: 1em;
        height: 1em;
        opacity: 0.35;
    }

    .back {
        text-align: right;
    }

    .back-button {
        padding-left: 1vw;
        padding-right: 1vw;
        padding-top: 2px;
        padding-bottom: 2px;
        background: #ef7926;
        color: #fff;
        border-color: white;
    }

    .sidenav {
        background-color: #002530;
        transition: 0.5s;
        position: fixed;
    }

    .sidenav a:hover {
        color: #f1f1f1;
    }


    .form-group {
        margin-left: 5%;
        margin-right: 5%;
    }

    hr {
        margin-top: 0;
        border-top-width: 2px;
        margin-bottom: 5px;
    }

    @media screen and (max-height: 450px) {
        .sidenav {
            padding-top: 15px;
        }

        .sidenav a {
            font-size: 18px;
        }
    }

    label {
        color: lightgray !important;
    }

    .topnav {
        background-color: white;
        overflow: hidden;
        padding: 1vh;
    }

    .select2-container--bootstrap .select2-selection {
        background-color: transparent;
    }

    .form-control {
        background-color: transparent;
        color: lightgray;
    }

    .select2-container--bootstrap .select2-selection--multiple .select2-search--inline .select2-search__field {
        background: none;
    }

    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
    }

    option {
        width: 10%;
    }


</style>
<style>
    @import "~leaflet/dist/leaflet.css";
    @import "~leaflet.markercluster/dist/MarkerCluster.css";
    @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

    .map-label {
        color: #000000bb;
        padding: 5px;
        font-size: 16px;
        text-shadow: 1px 1px 5px #fff, -1px -1px 5px #fff;
        font-weight: bolder;
        text-align: center;
    }

    .v-select .selected-tag {
        background-color: #e6e9ed !important;
        color: #4f5b6b !important;;
        font-size: .8em !important;;
        margin: 3px 5px !important;;
        padding: 6px !important;;
        white-space: normal !important;;
        width: 94% !important;;
        height: auto !important;;

    }

    .v-select .selected-tag .close {
        float: none;
        margin-right: 0;
        font-size: 20px;
        padding: 0;
        cursor: pointer;
        background: 0 0;
        border: 0;
        font-weight: 700;
        line-height: 1;
        color: #f58220;
        text-shadow: 0 1px 0 #fff;
        filter: alpha(opacity=20);
        opacity: 1;
        margin-left: 0;
    }

    .sugerencias-busqueda {

        overflow: visible !important;
        display: block;
        margin-left: auto;
        margin-right: auto;
        top: 0 !important;
        left: 0 !important;
    }

    h3 {
        background-color: rgba(0, 0, 0, .05);
        color: #003d51;
        font-size: 1.3em !important;
        font-weight: 700;
        line-height: 140%;
        text-transform: uppercase;
    }

    a {
        color: #002532;
        text-decoration: none;
    }
.label {
    margin-left: 5%;
}
    .detalles {
        overflow-y: auto;
        background-color: white;
        height: auto !important;
        padding: 0;
        margin-bottom: 0 !important;
    }

    .form-group {
        margin-bottom: 0 !important;
    }

    .v-select .dropdown-toggle .clear {
        float: none;
        margin-right: 0;
        font-size: 20px;
        padding: 0;
        cursor: pointer;
        background: 0 0;
        border: 0;
        font-weight: 700;
        line-height: 1;
        color: #f58220;
        text-shadow: 0 1px 0 #fff;
        filter: alpha(opacity=20);
        opacity: 1;
        margin-left: 0;
        visibility: hidden;
    }
    .btn {
        font-size: small;
    }
    .btn-dncp, .btn-primary {
        background-color: #f58220 !important;
        border-color: #f8a35b !important;;
        color: #fff !important;;
        transition: background-color .4s ease !important;;
    }

    .btn-bottom {
        margin-top: 2px;
    }

    .v-select .dropdown-toggle {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        display: block;
        padding: 0;
        background: none;
        border: 1px solid whitesmoke !important;
        border-radius: 4px;
        white-space: normal;
        width: 100%;
    }

    .dropdown {
        display: inline-flex;
        position: relative;
        vertical-align: top;
        width: 100%;
    }

    .vdp-datepicker * {
        box-sizing: border-box;
        width: 100%;
        background-color: transparent;
        color: lightgray;
        border-radius: 4px;
        border-width: thin;
        border-color: whitesmoke;
    }

    .input-group {
        display: table;
        width: 100%;
    }

    .vdp-datepicker__calendar {
        position: absolute;
        z-index: 100;
        background: #fff !important;
        width: 120% !important;
        border: 1px solid #ccc;

    }

    .vdp-datepicker__calendar .cell {
        display: inline-block;
        padding: 0 5px;
        width: 14.285714285714286%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        vertical-align: middle;
        border: 1px solid transparent;
        color: black;
    }

    .vdp-datepicker__calendar header span {
        display: block;
        line-height: 40px;
        color: black;
    }

    .v-select.single .selected-tag {
        background-color: #e6e9ed;
        border-color: transparent;
    }

    #app .dropdown li a {

        white-space: pre-line;
    }
    .d-center {
        display: flex;
        align-items: center;
    }

    .selected img {
        width: auto;
        max-height: 23px;
        margin-right: 0.5rem;
    }

    .v-select .dropdown li {
        border-bottom: 1px solid rgba(112, 128, 144, 0.1);
    }

    .v-select .dropdown li:last-child {
        border-bottom: none;
    }

    .v-select .dropdown li a {
        padding: 10px 20px;
        width: 100%;
        font-size: 1.25em;
        color: #3c3c3c;
    }

    .v-select .dropdown-menu .active > a {
        color: #fff;
    }

.hide-on-mobile {

}
    @media (max-width: 1080px) {
        .hide-on-mobile {
            display: none;
        }
    }

    .datos-abiertos-img {
        margin: 20px 0 0 5px !important;
        height: 20px !important;
        width: 120px !important;
    }
    .slogan {
        color: gray;
        text-align: center;

    }
    .btn-group {
        border: none;
    }

    /*
    * Sidebar
    */
    .sidebar {
        position: fixed;
        top: 60px;
        bottom: 0;
        left: 0;
        z-index: 1000;
        display: block;
        padding: 20px;
        overflow-x: hidden;
        overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
        background-color: #f5f5f5;
        border-right: 1px solid #eee;
    }

    /* Sidebar navigation */
    .nav-sidebar {
        margin-right: -21px; /* 20px padding + 1px border */
        margin-bottom: 20px;
        margin-left: -20px;
    }
    .nav-sidebar > li > a {
        padding-right: 20px;
        padding-left: 20px;
    }
    .nav-sidebar > .active > a,
    .nav-sidebar > .active > a:hover,
    .nav-sidebar > .active > a:focus {
        color: #fff;
        background-color: #428bca;
    }
    @media screen and (max-width: 991px) {

        form .btn {
            display: block;
            font-size: 14px;
            /* margin: 7px 0; */
            padding-bottom: 8px;
            padding-top: 8px;
            width: 100%;
            margin: 0;
        }
    }
    .myCSSClass {
        word-break: break-all;
        text-align: justify;

    }
    .botones {
        color: black !important;
        text-decoration: none;
        background-color: #e6e9ed;
        border-color: #4f5b6b;
    }
</style>
